import React, { useState, useEffect } from 'react';
import FilterListIcon from '@material-ui/icons/FilterList';
import { NumericRangePicker } from '../../DropdownMenu/NumericRangePicker.component';
import { useStyles } from './filters.styles';
import { RangeFilterProps } from './filters.types';
import TooltipOne from '../../../components/TooltipOne/TooltipOne.component';

interface RangeFilterAdditionalProps extends RangeFilterProps<string> {
  component?: JSX.Element | null;
  noAnswerFilter?: JSX.Element | null;
  isNoAnswerFilter?: boolean;
  advancedFilter?: JSX.Element | null;
  isAdvancedFilter?: boolean;
  onAdvancedFilterReset?: () => void;
  initRangeFrom?: string;
  initRangeTo?: string;
  additionalFlagForActiveFilter?: boolean;
}
export const RangeFilter: React.FC<RangeFilterAdditionalProps> = ({
  fromValueName,
  toValueName,
  onChange,
  resetFilter,
  component,
  noAnswerFilter,
  isNoAnswerFilter,
  advancedFilter,
  isAdvancedFilter,
  onAdvancedFilterReset,
  initRangeFrom,
  initRangeTo,
  additionalFlagForActiveFilter,
}) => {
  const classes = useStyles();
  const [rangeFromFilter, setRangeFromFilter] = useState<string>(initRangeFrom === undefined ? '' : initRangeFrom);
  const [rangeToFilter, setRangeToFilter] = useState<string>(initRangeTo === undefined ? '' : initRangeTo);
  const [anchorElRange, setAnchorElRange] = useState<SVGSVGElement | HTMLElement | null>(null);

  useEffect(() => {
    if (resetFilter) {
      setRangeFromFilter('');
      setRangeToFilter('');
    }
  }, [resetFilter]);

  const handleRangeFilterChange = (range: string, typeOfChange: 'from' | 'to' | 'clear') => {
    if (typeOfChange === 'from') {
      setRangeFromFilter(range);
      onChange(fromValueName, range);
    } else if (typeOfChange === 'to') {
      setRangeToFilter(range);
      onChange(toValueName, range);
    } else if (typeOfChange === 'clear') {
      setRangeFromFilter('');
      setRangeToFilter('');
      onChange(fromValueName, '');
      onChange(toValueName, '');
      onChange('examTaskNumbersWithNoAnswer', '');
      onAdvancedFilterReset && onAdvancedFilterReset();
    }
  };

  const handleClickRangeFilter = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    if (!anchorElRange) {
      setAnchorElRange(event.currentTarget);
    } else setAnchorElRange(null);
  };

  return (
    <>
      <TooltipOne title="Ustaw filtr do wyszukiwania: Suma punktów" placement="top">
        <FilterListIcon
          className={
            (rangeToFilter + rangeFromFilter).length > 0 ||
            isAdvancedFilter ||
            isNoAnswerFilter ||
            additionalFlagForActiveFilter
              ? classes.activeFilter
              : ''
          }
          onClick={handleClickRangeFilter}
          aria-controls="Range-menu"
          aria-haspopup="true"
        />
      </TooltipOne>
      <NumericRangePicker
        anchorEl={anchorElRange}
        setAnchorEl={setAnchorElRange}
        firstValue={rangeFromFilter}
        secondValue={rangeToFilter}
        onChange={handleRangeFilterChange}
        component={component}
        noAnswerFilter={noAnswerFilter}
        advancedFilter={advancedFilter}
      />
    </>
  );
};
